import { defineStore } from 'pinia';

// Типы (интерфейсы)
export interface User {
  id: number | string;
  telegram_id: number | string;
  first_name: string;
  last_name: string;
  username: string;
  steam_username: string;
  pay_method: 'sbp' | 'card';
  pay_method_display: string;
  vip: IPersonalDiscount;
}

interface IPersonalDiscount {
  level: number;
  percent: number;
  history_sum_paid: number;
  grid: {
    level: number,
    sum: number,
    percent: number,
  }[]
}

interface UserCreatePayload {
  telegram_id: number | string;
  first_name: string;
  last_name?: string; // last_name может быть необязательным
  username: string;
}

interface ErrorResponse {
  message: string;
  // Другие поля, если есть
}

// Получаем URL из переменных окружения
const BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Проверка, что URL задан
if (!BASE_URL) {
  console.error('VITE_API_BASE_URL is not defined in .env file!');
  // Можно выбросить ошибку, чтобы остановить выполнение, если URL критически важен
  // throw new Error('VITE_API_BASE_URL is not defined!');
}

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null as User | null,
  }),

  actions: {
    async fetchCurrentUser(id: string) {
      try {
        const response = await fetch(`${BASE_URL}/api/telegram_users/${id}`, { // Используем BASE_URL
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });

        if (response.ok) {
          this.user = await response.json() as User;
        } else {
          this.user = null;
          console.error('Ошибка при загрузке данных пользователя:', response.status, response.statusText);
          const errorData = await response.json() as ErrorResponse;
          if (response.status === 404) {
            // showNotification(`Пользователь не найден.`, 'error');
          } else if (response.status >= 500) {
            // showNotification(`Ошибка сервера. Попробуйте позже`, 'error');
          } else {
            // showNotification(`Не удалось загрузить данные пользователя: ${errorData.message}`, 'error');
          }
        }
      } catch (error) {
        console.error('Сетевая ошибка:', error);
        // showNotification('Произошла ошибка. Пожалуйста, проверьте подключение к интернету.', 'error');
      }
    },

    async createUser(user: UserCreatePayload) {
      try {
        const response = await fetch(`${BASE_URL}/api/telegram_users/`, { // Используем BASE_URL
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(user),
        });

        if (response.ok) {
          this.user = await response.json() as User;
        } else {
          const errorData = await response.json() as ErrorResponse;
          console.error('Ошибка создания пользователя:', response.status, response.statusText);
          // showNotification(`Ошибка создания пользователя: ${errorData.message}`, 'error');
        }
      } catch (error) {
        console.error('Сетевая ошибка при создании пользователя:', error);
        // showNotification('Произошла ошибка при создании пользователя. Пожалуйста, проверьте подключение к интернету.', 'error');
      }
    },

    async updateUser(user: UserCreatePayload) {
      try {
        const response = await fetch(`${BASE_URL}/api/telegram_users/${user.telegram_id}`, { // Используем BASE_URL
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(user),
        });

        if (response.ok) {
          this.user = await response.json() as User;
        } else {
          const errorData = await response.json() as ErrorResponse;
          console.error('Ошибка обновления пользователя:', response.status, response.statusText);
          // showNotification(`Ошибка обновления пользователя: ${errorData.message}`, 'error');
        }
      } catch (error) {
        console.error('Сетевая ошибка при обновлении пользователя:', error);
        // showNotification('Произошла ошибка при обновлении пользователя. Пожалуйста, проверьте подключение к интернету.', 'error');
      }
    },
  },
});